import { Controller } from "@hotwired/stimulus"

// Automatyczne generowanie prefiksu konta z nazwy
export default class extends Controller {
  static targets = ["name", "prefix"]

  connect() {
    // Sprawdź czy prefix jest pusty - jeśli tak, włącz auto-generowanie
    this.autoGenerate = !this.prefixTarget.value || this.prefixTarget.value.trim() === ""
  }

  // Wywoływane gdy użytkownik wpisuje nazwę konta
  generatePrefix() {
    // Generuj prefix tylko jeśli pole prefix jest puste lub było auto-generowane
    if (!this.autoGenerate) {
      return
    }

    const name = this.nameTarget.value
    const prefix = this.parameterize(name)
    this.prefixTarget.value = prefix
  }

  // Gdy użytkownik ręcznie edytuje prefix, wyłącz auto-generowanie
  manualEdit() {
    this.autoGenerate = false
  }

  // Gdy użytkownik usuwa cały prefix, włącz z powrotem auto-generowanie
  checkEmpty() {
    if (!this.prefixTarget.value || this.prefixTarget.value.trim() === "") {
      this.autoGenerate = true
      this.generatePrefix()
    }
  }

  // Funkcja konwertująca tekst na bezpieczny format URL (podobnie jak Rails parameterize)
  parameterize(text) {
    if (!text) return ""

    // Mapa polskich znaków na ich odpowiedniki ASCII
    const polishChars = {
      ą: "a",
      ć: "c",
      ę: "e",
      ł: "l",
      ń: "n",
      ó: "o",
      ś: "s",
      ź: "z",
      ż: "z",
      Ą: "a",
      Ć: "c",
      Ę: "e",
      Ł: "l",
      Ń: "n",
      Ó: "o",
      Ś: "s",
      Ź: "z",
      Ż: "z"
    }

    let result = text.trim()

    // Zamień polskie znaki
    Object.keys(polishChars).forEach(char => {
      result = result.replace(new RegExp(char, "g"), polishChars[char])
    })

    // Konwersja na lowercase
    result = result.toLowerCase()

    // Zamień spacje i znaki specjalne na myślniki
    result = result.replace(/[^a-z0-9]+/g, "-")

    // Usuń myślniki z początku i końca
    result = result.replace(/^-+|-+$/g, "")

    // Zamień wielokrotne myślniki na pojedyncze
    result = result.replace(/-+/g, "-")

    return result
  }
}
